import React from 'react'

const Navbar = () => {
    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light bg-light" >
                <div className="container-fluid">
                    <div className="navbar-brand">CRYPTO PRICE TRACKER</div>
                </div>
            </nav>
        </div>
    )
}

export default Navbar
